module.exports = __webpack_public_path__ + "static/media/ursa.82556ce7.png";